import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/pspSettings/conditions', request)
}

export {get}
